import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import SearchBar from './SearchBar'
import InfluencersList from './InfluencersList'
import NewAuthenticationModal from './NewAuthenticationModal'
import NewInfluencerModal from './NewInfluencerModal'
import WaitingListModal from './WaitingListModal'
import TagsManagerModal from '../Tags/TagsManagerModal'
import { SearchContext } from '../../../contexts/SearchContext'

export default observer(function InfluencersContent() {
  const { newAuthenticationModalOpen, toggleNewAuthenticationModal, newInfluencerModalOpen, toggleNewInfluencerModal, waitingListModalOpen, toggleWaitingListModal, tagsModalOpen, toggleTagsModal, bumpTagsVersion } = useContext(SearchContext)
  return (
    <div
      className="pt-12 bg-rb-grey dark:bg-rb-dark-mode-background"
      style={{
        minHeight: 'calc(100vh)'
      }}
    >
        <SearchBar />
        <InfluencersList />
        <NewAuthenticationModal isOpen={newAuthenticationModalOpen} setIsOpen={toggleNewAuthenticationModal} />
        <NewInfluencerModal isOpen={newInfluencerModalOpen} setIsOpen={toggleNewInfluencerModal} />
        <WaitingListModal isOpen={waitingListModalOpen} setIsOpen={toggleWaitingListModal} />
        <TagsManagerModal isOpen={tagsModalOpen} onClose={toggleTagsModal} onTagsChanged={bumpTagsVersion} />
    </div>
  )
})